
import api from '@shared/services/api';
import { ApiResponse } from '@shared/types/api';
import { OrganizationProfile, OrganizationsResponse } from '@shared/types/organization';


export class OrganizationsService {
  private static readonly BASE_URL = '/organizations';

  /**
   * Get list of organizations with optional search and pagination
   */
  static async getOrganizations(
    page = 1,
    limit = 10,
    search = ''
  ): Promise<OrganizationsResponse> {
    try {
      const response = await api.get<ApiResponse<OrganizationsResponse>>(this.BASE_URL, {
        params: { page, limit, search },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching organizations:', error);
      throw error;
    }
  }

  /**
   * Get detailed profile of a specific organization
   */
  static async getOrganizationById(organizationId: string): Promise<OrganizationProfile> {
    try {
      const response = await api.get<ApiResponse<OrganizationProfile>>(`${this.BASE_URL}/${organizationId}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching organization profile for ID ${organizationId}:`, error);
      throw error;
    }
  }

  /**
   * Get current user's organization
   */
  static async getMyOrganization(): Promise<OrganizationProfile | null> {
    try {
      const response = await api.get<OrganizationProfile>(`${this.BASE_URL}/me`);
      return response.data;
    } catch (error) {
      console.error('Error fetching my organization:', error);
      throw error;
    }
  }

  /**
   * Update current user's organization
   */
  static async updateMyOrganization(data: Partial<OrganizationProfile>): Promise<OrganizationProfile> {
    try {
      const response = await api.put<OrganizationProfile>(`${this.BASE_URL}/me`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating organization:', error);
      throw error;
    }
  }
}
